import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import useDialogContext from '../../../../../../../../hooks/dialog/useDialogContext';

const RequestCertificateButton = (): JSX.Element => {
  const { t } = useTranslation();
  const { openDialog } = useDialogContext();

  return (
    <Button
      className='w-full md:max-w-fit flex'
      label={t('certificatesPage.tabs.supplierCertificatesTab.buttons.requestCertificate')}
      onClick={() => {
        openDialog('request-certificate-dialog');
      }}
    />
  );
};

export default RequestCertificateButton;
